module.exports = __webpack_public_path__ + "img/icon-2.ad8d94d7.png";